import { Paper, Text, Title, Image, Divider, Flex } from "@mantine/core";
import classes from "./Login.module.css";
import Logo from "../../assets/logo-02-cropped.svg";
import { GoogleButton } from "./GoogleButton";
import { AppleButton } from "./AppleButton";
import LoginForm from "./EmailLogin";

export function NewLogin() {
  return (
    <div className={classes.wrapper}>
      <Paper className={classes.form} radius={0} p={30}>
        <Image
          src={Logo}
          alt="Logo"
          width="auto"
          fit="contain"
          height={80}
          mb={10}
        />
        <Title order={2} className={classes.title} ta="center" mt="md" mb={20}>
          Welcome to Congrs
        </Title>

        <Text size="md" fw={500}>
          Login with
        </Text>
        <Flex direction="column" gap="md" mt="md">
          <GoogleButton radius="xl">Google</GoogleButton>
          <AppleButton radius="xl">Sign in with Apple</AppleButton>
        </Flex>

        <Divider
          label="Or continue with email"
          labelPosition="center"
          my="lg"
        />

        <LoginForm />
      </Paper>
    </div>
  );
}
